import Model from './PricingModel';
import View from './PricingView';
import CartController from '../CartController';

class Controller extends CartController {
  constructor(model, view) {
    super();
    this._model = model;
    this._view = view;

    this._view.on('purchase', purchase => {
      this.cart.add(purchase);
    })
    
    this.cart.on('addedToCart', result => {
      window.location.href = SITE_URL + '/cart'
    })
  }
}

const Pricing = (function() {
  return {
    init: () => {
      const model = new Model();
      const view = new View(model);
      const controller = new Controller(model, view);
    }
  }
})()

export default Pricing;